import { useState, useContext, useRef } from "react";
import INTOUCH_API from "../../services/Api";
import PersonalAccount from "../../store/PersonalAccount";
import { MODAL_TYPES } from "../../utils/emitter";
import useModalActions from "../../hooks/useModalActions";
import useCurrentGame from "../../hooks/useCurrentGame";
import Game from "../../store/Game";
import { SOCKET_EVENTS, SocketContext } from "../../components/SocketProvider";
export default function useController() {
  const { sendEvent } = useContext(SocketContext);
  const { closeModal } = useModalActions();
  const { getCurrentGame, removeCurrentGame } = useCurrentGame();
  const [gameIsDeleting, setGameIsDeleting] = useState(false);
  const gameIdRef = useRef(null);

  const onPayload = (gameId) => {
    gameIdRef.current = gameId;
  };

  const removeGame = async () => {
    setGameIsDeleting(true);
    const game = getCurrentGame();
    const gameId = gameIdRef.current;
    
    try {
      await INTOUCH_API.requestManager(
        "remove_game",
        { gameId },
        () => {
          // Локально убираем игру из стора
          sendEvent(SOCKET_EVENTS.REQUEST_REFRESH_GAME_DATA, {
            invitedUserId: game?.invitedUserId,
            inviterUserId: game?.userId,
            room: gameId,
          });
          PersonalAccount.removeGameById(gameId);
          if (game && game.id === gameId) {
            removeCurrentGame();
          }
          if (Game.game && Game.game.id === gameId) {
            Game.setGame(null);
          }
          Game.removeInsightEventsData(gameId);
        }
      );
      
      // Обновляем события отдельно (не блокирует закрытие модалки)
      INTOUCH_API.requestManager("get_game_events", null, (response) => {
        Game.setGameEventsData(response.data);
      });
    } finally {
      gameIdRef.current = null;
      setGameIsDeleting(false);
      closeModal(MODAL_TYPES.REMOVE_GAME);
    }
  };
  return {
    onPayload,
    gameIsDeleting,
    removeGame,
  };
}
